import { Breadcrumbs as MuiBreadcrumbs, Link } from "@mui/material";

import { styled } from "@mui/material/styles";
import { spacing } from "@mui/system";

import { useBreadcrum } from "./BreadcrumContext";

interface BreadcrumItem {
  link?: string;
  onClick?: () => void;
  onRightClick?: () => void;
  title: string;
}
interface BreadcrumProps {
  items?: BreadcrumItem[];
}

const BreadcrumItem = ({ item }: { item: BreadcrumItem }) => {
  if (item.link) {
    return <Link>{item.title}</Link>;
  }
  if (item.onClick) {
    return (
      <Link
        sx={{
          cursor: "pointer",
        }}
        onClick={() => item.onClick?.()}
        onContextMenu={(event) => {
          event.preventDefault();
          item.onRightClick?.();
        }}
      >
        {item.title}
      </Link>
    );
  }
  return <></>;
};

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
export const BreadcrumList = ({ items }: BreadcrumProps) => {
  const bc = useBreadcrum();
  return (
    <Breadcrumbs aria-label="Breadcrumb" mt={2}>
      {(items || bc.items).map((item, i) => (
        <BreadcrumItem item={item} key={`${item.title}-${i}`} />
      ))}
    </Breadcrumbs>
  );
};
